import { Component, OnInit } from '@angular/core';
import { Globals } from '../globals';

@Component({
  selector: 'app-notfound',
  templateUrl: './notfound.component.html',
  styleUrls: ['./notfound.component.css']
})
export class NotfoundComponent implements OnInit {

  theGlobal: any;

  constructor(globals: Globals) { 
    this.theGlobal = globals;
  }

  ngOnInit(): void {
    this.loadScripts();
    this.theGlobal.menuLoadder();
  }

  loadScripts(){
    const scriptsToLoad = [
      "../assets/js/notfound/error_404.js"
    ];

    for(let i = 0; i < scriptsToLoad.length; i++){
      const body = <HTMLDivElement>document.body;
      let divScripts = document.getElementById('personalizedParallax');
      const script = document.createElement('script');
      script.innerHTML = '';
      script.src = scriptsToLoad[i];
      script.async = false;
      script.defer = true;
      divScripts.appendChild(script);
    }
  }


}
